import React, { useState } from 'react';
import { InvitationData } from 'types/Invitation';
import PDFViewer from 'components/PDFViewer';
import {
  Form,
} from 'react-bootstrap';
// import classnames from 'classnames';
import LinkInvitationFooter from '../Footer';

type LinkInvitationStep4Props = {
  invitationData: InvitationData | null;
  pdfNdaUrl?: string
  onNext: ( values:any ) => void
};

function LinkInvitationStep4( { onNext, pdfNdaUrl, invitationData }: LinkInvitationStep4Props ) {
  const [ndaSigned, setNdaSignet] = useState( false );
  return (
    <>
      <h2 className="text--black5 text-center">Aceptación del acuerdo de confidencialidad</h2>

      {invitationData?.ndaEstado !== 'COMPLETADO' && (
      <div className="mt-4 pt-2 text--black5">
        {pdfNdaUrl && (
          <PDFViewer
            title="PDF Viewer"
            src={pdfNdaUrl}
            allowFullScreen
            style={{
              width: '100%',
              height: '60vh',
              border: 'none',
            }}
          />
        )}
        <div className="d-flex align-items-center mt-4" />
      </div>
      )}

      <div className="d-flex align-items-center">

        <span
          className="text--bold"
        >
          <Form.Check
            type="switch"
            className="switch-generic"
            disabled={false}
            defaultChecked={ndaSigned}
            onChange={() => {
              setNdaSignet( !ndaSigned );
            }}
          />
        </span>

        <span className="ms-3">
          He leído y acepto los términos del Acuerdo de Confidencialidad
        </span>
      </div>

      {ndaSigned && (
        <LinkInvitationFooter
          onNext={onNext}
          nextText="Aceptar"
        />
      )}
      {!ndaSigned && (
        <LinkInvitationFooter
          onNext={() => {}}
          nextText="Aceptar"
          disabledNext
        />
      )}

    </>
  );
}

export default LinkInvitationStep4;
